import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';
import { DetailsBooking } from 'types';
import { FormattedDate } from 'components/Formatters';
import Timeline from 'components/Timeline';
import RefundTimelineItems from './RefundTimelineItems';

interface Props {
  booking: DetailsBooking;
}

const PolicyTimeline: FC<Props> = ({ booking }) => {
  if (booking.reservation.cancellationPolicy?.cancellationWindows[0].cancellationType === 'NON_REFUNDABLE') {
    return null;
  }

  return (
    <Box py={8} px={5}>
      <Timeline>
        <RefundTimelineItems booking={booking} />
        <Timeline.Item
          iconName="home"
          iconProps={{
            color: 'white',
            bg: 'puertoRico',
            size: 20,
            p: '2px',
            ml: '-11px',
          }}
          state="pending"
          title={<FormattedDate date={booking.reservation.checkInDateTime} />}
          description={`Check-in to ${booking.reservation.property.name}`}
        />
      </Timeline>
    </Box>
  );
};

export default PolicyTimeline;
